import { IUser } from "@imaginelearning/mps-api-service";
import { LicensedEnum, IAssessment } from "imagineplus-assessments/types";
import { useState, useEffect, useCallback } from "react";
import { fetchFormatives, fetchDiagnosticsAndBenchmarks, filterAssessments } from "./assessment-data";

export default function useAssessmentData(user: IUser, licensed: LicensedEnum, subject: string) {
  const [loading, setLoading] = useState(true);
  const [rawAssessments, setRawAssessments] = useState<IAssessment[] | undefined>();
  const [assessments, setAssessments] = useState<IAssessment[] | undefined>();

  const loadData = useCallback(() => {
    setLoading(true);
    Promise.all([fetchFormatives(user), fetchDiagnosticsAndBenchmarks(user)])
      .then(([assessments, formatives]) => {
        setRawAssessments([...assessments, ...formatives]);
      })
      .catch((error) => {
        console.error("Error fetching assessment data:", error);
        setRawAssessments([]);
      });
  }, [user]);

  useEffect(() => {
    if (user && loadData && licensed !== LicensedEnum.UNKNOWN) {
      if (licensed === LicensedEnum.UNLICENSED) {
        setLoading(false);
      } else {
        loadData();
      }
    }
  }, [user, licensed, loadData]);

  useEffect(() => {
    if (rawAssessments && subject) {
      setLoading(true);
      const filteredassessments = filterAssessments(rawAssessments, subject);
      setAssessments(filteredassessments);
      setLoading(false);
    }
  }, [rawAssessments, subject]);

  return { loading, assessments, reloadData: loadData };
}
